// extracted by mini-css-extract-plugin
export default {"datenschutz":"Datenschutz_datenschutz__uWNw0","datenschutzContainer":"Datenschutz_datenschutzContainer__n2Y7x","datenschutzHeadline":"Datenschutz_datenschutzHeadline__31ozs"};